const updateStatus = Object.freeze({
    OK: 'ok',
    INPROGRESS: 'inprogress',
    NEEDUPDATE: 'needupdate',
    ERROR: 'error'
});

export default updateStatus;